/**
 *  Events related to managing channel subscriptions
 */
// change the game that is currently selected
export const SELECT_GAME = 'select-game';
export const SELECT_CATEGORY = 'select-category';
export const NO_GAME_FOUND = 'no-game-found';
export const SEARCH_RESULTS = 'search-results';

export const CLEAR_ERRORS = 'clear-errors';

export const SUBSCRIBED = 'subscribed';
export const UNSUBSCRIBED = 'unsubscribed';

export const UNSUBSCRIBE_LAST_INTEREST = 'unsubscribe-last-interest';

// used to indicate the saving of data is in progress
export const SAVING = 'saving';

// used to indicate a step has finished saving
export const SAVED = 'saved';

// used to indicate a save failed
export const SAVE_FAILED = 'save-failed';

// used to indicate a game's pinning state has changed
export const PIN_MESSAGES = 'pin-messages';
export const DONT_PIN_MESSAGES = 'dont-pin-messages';
export const MAX_PINS = 'max-pins';

export const ADD_FORUM_TAG = 'add-forum-tag';
export const REMOVE_FORUM_TAG = 'remove-forum-tag';

export const USE_THREAD = 'use-thread';
export const THREAD_ID_UPDATED = 'thread-id-updated';
export const DONT_USE_THREAD = 'dont-use-thread';

export const CLEAR_ROLE_MENTION = 'clear-mentions';
export const REMOVE_ROLE_MENTION = 'remove-mention';
export const ADD_ROLE_MENTION = 'add-mention';

/**
 *  Events related to billing
 */
export const PREMIUM_SERVER_SELECTED = 'premium-server-selected';
export const PREMIUM_SERVER_COST_UPDATED = "premium-server-cost-updated";
export const BILLING_FREQUENCY_ANNUAL = 'frequency-annual';
export const BILLING_FREQUENCY_MONTHLY = 'frequency-monthly';
export const PAYMENT_METHOD_DELETE_CONFIRM = 'payment-method-delete-confirm';
export const PREMIUM_SERVER_CANCEL = 'premium-server-cancel';
export const PREMIUM_SERVER_RESUME = 'premium-server-resume';
export const PREMIUM_SERVER_UPGRADED = 'premium-server-upgraded';
export const COPY_TO_CLIPBOARD_DATA_COPIED = "ctc-copied";
export const COPY_TO_CLIPBOARD_FORCE_RESET_DATA = "ctc-force-reset-data";
export const CURRENCY_CHANGED = 'currency-changed';
export const CURRENCY_LOCKED = 'currency-locked';


